import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import Main from "./Main/Main";
import ProductConfigurator from './ProductConfigurator/ProductConfigurator';
import { Spinner } from 'spin.js';

//const Main = lazy(() => import('./Main/Main'));

//Previous implementation: "customerBucketName" : "exampleclient"
//TODO: Create custom cloudfront url
//Json isn't valid
const defaultModelViewerData = {
  customerBucketName: "growmexampleclient",
  cloudFrontUrl: "https://d1kemlkva5bpmc.cloudfront.net",
  //productSKU : "GS-SS3-01",
  //productSKU : "ZN-M8H-01",
  //productSKU : "ZN-M6S-01",
  //productSKU : "ZN-M6S-02",
  //productSKU : "ZN-M6S-03",
  // productSKU: "SH-AAV-02",
  //productSKU: "WC-RTT-01",
   productSKU: "BA-DDB-01",
  //productSKU: "BA-DDB-01",
  //productSKU: "RF-LB1-01",
  //productSKU: "RF-MR-01",
  //productSKU: "RFT-RM-NR3",
  //productSKU: "RFT-ALC-PCASE-40x80",
  //productSKU: "SC-HDC-01",
  //productSKU : "ZN-N2H-01",
  // productSKU : "HF-B3S-01",
  //productTags: [],
  productTags: [],
  // "smallObject"
  productSettings: {
    "ThreeSixtyViewer": -1,
    "Lifestyle": -1,
    "ModelViewer": 1,
    "orientation": "horizontal",
    "showDimensions": true,
    "sceneBackgroundColour": "white",
    "isAREnabled": true,
    "qrCode": true,
    "showRotationIconOnStartup": true,
    "windowMargin": 40,
    "react360ImagesCount": 36,
    "is180Pan": false,
    "enableConfigurator": false,
    "growm360autoplaySpeed": 15,
    "isBaked": true,
    "constantScale": false,
    "switchToFullScreen" : 1175,
    "arrowColour": "red",
    "buttonsMargin": 16,
    "viewerMargin": 0,
    "viewerMarginLeft": 30,
    "modelViewerMargin": 0,
    "additionalButtonsMaxSize": 200,
    "showDimensionsAtStart": false,
    "reversableAnimation": true,
    "multiModels": true,
    "showProductButtons": true
  }
};

const databaseType = {
  shopify: "shopify",
  wooCommerce: "woocommerce",
  test: "test",
};

//TODO: Look at using json to set more attributes. Could be done on the php side and still passed as attributes here
//Downside is that you'd need to implement that same code on every website. Downside of reading json from react is that it takes time
//Passing the json directly here as an argument would be good. 
//Only pass website wide parameters in that file as we need to load variants correctly
const ProductViewer = (
  { showAdditionalButtons, rootDiv }
) => {
  //TODO: Add parameters to productSettings: black background, sizing for small objects + divide dimensions, AR. 
  //If value is below zero, don't show that element as first element, i.e. rule out if < 0
  //Need to parse the whole bucket and instantiate app each time, using props here, where you get the productFolder from each time
  const [loading, setLoading] = useState(true);
  const [customerBucketName, setCustomerBucketName] = useState(document.getElementById(rootDiv).getAttribute('data-customer-bucket-name'));
  const [cloudFrontUrl, setCloudFrontUrl] = useState(document.getElementById(rootDiv).getAttribute('data-cloudfront-url'));
  const [productSKU, setProductSKU] = useState(document.getElementById(rootDiv).getAttribute('data-product-sku'));
  const [showProductButtons, setShowProductButtons] = useState(document.getElementById(rootDiv).getAttribute('data-showproduct-buttons'));
  const [productVariants, setProductVariants] = useState([]);
  const [productVariantsAttrTest, setProductVariantsAttrTest] = useState([]);
  const [productVariantsTest, setProductVariantsTest] = useState([]);
  const [productTags, setProductTags] = useState(() => {
    const tagsString = document.getElementById(rootDiv).getAttribute('data-product-tags');
    try {
      return tagsString ? JSON.parse(tagsString) : defaultModelViewerData.productTags;
    } catch (error) {
      console.error("Error parsing product tags:", error);
      return defaultModelViewerData.productTags;
    }
  });
  const [productSettings, setProductSettings] = useState(document.getElementById(rootDiv).getAttribute('data-product-settings'));
  const [isAutoPlay, setIsAutoplay] = useState(true);
  const [isConfiguratorEnabled, setIsConfiguratorEnabled] = useState(false);
  const [enableConfigurator, setEnableConfigurator] = useState(false);
  const [meshClicked, setMeshClicked] = useState(null);
  const spinnerContainerRef = useRef(null); // Create a reference for the spinner container
  const spinnerInstanceRef = useRef(null); // Store the Spinner instance
  const [variantFoldersNames, setVariantFoldersNames] = useState();

  const toggleConfigurator = () => {
    console.log('toggle configurator, isConfigurator:', isConfiguratorEnabled);
    setIsConfiguratorEnabled((prev) => !prev);
  }

  const onMeshClicked = (mesh) => {
    console.log('Mesh clicked:', mesh);
    setMeshClicked({ id: Date.now(), name: mesh });
    //setMeshClicked(mesh);
  }

  // Setup event listener for SKU change
  useEffect(() => {
    const rootElement = document.getElementById(rootDiv);

    if (!rootElement) return;

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-product-sku"
        ) {
          const newProductSKU = rootElement.getAttribute("data-product-sku");
          if (newProductSKU && newProductSKU !== productSKU) {
            setProductSKU(newProductSKU);
            console.log("SKU changed to:", newProductSKU);
          }
        }
      }
    });

    // Start observing changes to attributes
    observer.observe(rootElement, { attributes: true });

    return () => observer.disconnect(); // Cleanup on unmount

  }, [productSKU, rootDiv]);

  // Fetch data when productSKU changes
  useEffect(() => {
    const getData = async () => {
      const rootElement = document.getElementById(rootDiv);
      const productVariantsAttr = rootElement.getAttribute('data-product-variants');
      const productVariantsAttrTest = rootElement.getAttribute('data-product-variants-test');

      const productVariantsTestArray = '["SC-HDC-01","HF-B3S-01","HF-B3S-02"]';
      // const productVariantsTestArrayFull = `[
      //   {
      //     "sku": "WC-EBA-01",
      //     "price": "2500",
      //     "sale_price": "",
      //     "regular_price": "2500",
      //     "weight": "",
      //     "dimensions": "N/A",
      //     "attributes": {
      //       "pa_attribute_fabric": "oat"
      //     }
      //   },
      //   {
      //     "sku": "WC-EBA-02",
      //     "price": "2500",
      //     "sale_price": "",
      //     "regular_price": "2500",
      //     "weight": "",
      //     "dimensions": "N/A",
      //     "attributes": {
      //       "pa_attribute_fabric": "biscuit"
      //     }
      //   }
      // ]`;

      //TODO: Add test data for beds following implemented structure
      // const productVariantsTestArrayFull = `[
      //   {
      //     "sku":"RF-LB1-01",
      //     "price":"9.99",
      //     "sale_price":"",
      //     "regular_price":"9.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"140x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"140x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"140x200",
      //       "pa_attribute_headboard":"style1",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   },
      //   {
      //     "sku":"RF-LB2-01",
      //     "price":"4.99",
      //     "sale_price":"",
      //     "regular_price":"4.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"140x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"140x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"140x200",
      //       "pa_attribute_headboard":"style2",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   },
      //     {
      //     "sku":"RF-LB2-02",
      //     "price":"4.99",
      //     "sale_price":"",
      //     "regular_price":"4.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"160x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"160x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"160x200",
      //       "pa_attribute_headboard":"style2",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   }
      // ]`;

      //Farbe is only switching the colour, nothing else. Grosse is determining the size extension of the file inside the folder
      //Style is a different folder inside Headboard => extract the 2 words to know where to look.
      //Might be easier to have everything in one folder and use a naming convention
      //e.g. Headboard_style2_Weiss_140x100. Parse attributes into a different struct, so we can then easily handle values
      //i.e. headboard: {color: white, style: style2, ...0}. Then append values with underscores to generate Headboard_style2_Weiss_140x100.
      //Pass these strings into an array to Main, we'll handle getting hold of model and setting colour there (create a new component for that)
      const productVariantsTestArrayFull = `[
        {
          "sku":"RF-LB1-01",
          "price":"9.99",
          "sale_price":"",
          "regular_price":"9.99",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RF-LB2-01",
          "price":"4.99",
          "sale_price":"",
          "regular_price":"4.99",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RF-LB2-02",
          "price":"4.99",
          "sale_price":"",
          "regular_price":"4.99",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        }
      ]`;

      /*
      mattress_royale_140x200','bed_frame_140x200_noFeet', 'bed_structure_140x200_noFeet','headboard_225x120_style2'
      */

      //Need to get variants for configurator somehow
      //Then simply swap sku depending on variables. Find out how that works in shopify.
      //We've got an issue with product variants here => create a separate parameter and just parse the json for now
      if (productVariantsAttr) {
        setProductVariants(JSON.parse(productVariantsAttr));
      }
      // else {
      //   setProductVariants(JSON.parse(productVariantsTestArrayFull));
      //   console.log('PRODUCT VARIANTS:', JSON.parse(productVariantsTestArrayFull));
      // }

      if (productVariantsAttrTest) {
        console.log('PRODUCT VARIANTS:', productVariantsAttrTest);
        //Pass this down to ProductConfigurator
        setProductVariantsAttrTest(JSON.parse(productVariantsAttrTest));
      }
      else {
        setProductVariantsAttrTest(JSON.parse(productVariantsTestArrayFull));
      }

      if (!rootElement.getAttribute('data-customer-bucket-name')) {
        setCustomerBucketName(defaultModelViewerData.customerBucketName);
      }
      if (!rootElement.getAttribute('data-cloudfront-url')) {
        setCloudFrontUrl(defaultModelViewerData.cloudFrontUrl);
      }
      if (!rootElement.getAttribute('data-product-sku') && !productSKU) {
        setProductSKU(defaultModelViewerData.productSKU);
      }
      if (!rootElement.getAttribute('data-showproduct-buttons')) {
        setShowProductButtons(defaultModelViewerData.productSettings.showProductButtons);
      }
      if (!rootElement.getAttribute('data-product-settings')) {
        setProductSettings(JSON.stringify(defaultModelViewerData.productSettings));
      }
      console.log('Json config file:', productSettings);
      setLoading(false);
    };
    getData();

  }, [productSKU, productSettings]);

  useEffect(() => {
    console.log('new product folder:', productSKU);
    setProductSKU(productSKU);
  }, [productSKU]);

  useEffect(() => {
    if (typeof productSettings === 'string') {
      const serialisedProductSettings = JSON.parse(productSettings);
      const tempEnableConfigurator = serialisedProductSettings.enableConfigurator;
      setEnableConfigurator(tempEnableConfigurator);
    }
  })

  useEffect(() => {
    const handleDisplayModel = (event) => {
      const { sku, variants } = event.detail;
      // Logic to display the 3D model based on the SKU and variants
      console.log("Received SKU:", sku, "Variants:", variants);
      // Update state or call a function to render the model
    };

    window.addEventListener("displayProduct", handleDisplayModel);

    return () => {
      window.removeEventListener("displayProduct", handleDisplayModel);
    };
  }, []);

  useEffect(() => {
    // Spinner options
    const spinnerOptions = {
      lines: 12, // The number of lines to draw
      length: 0, // The length of each line
      width: 5, // The line thickness
      radius: 10, // The radius of the inner circle
      scale: 4, // Scales overall size
      corners: 1, // Corner roundness (0..1)
      color: '#000', // CSS color or array of colors
      fadeColor: 'transparent', // CSS color or array of colors
      speed: 1, // Rounds per second
      rotate: 0, // The rotation offset
      animation: 'spinner-line-fade-quick', // The CSS animation name
      direction: 1, // 1: clockwise, -1: counterclockwise
      zIndex: 2e9, // The z-index (defaults to 2000000000)
      className: 'spinner', // CSS class to assign to the spinner
      top: '50%', // Top position relative to parent
      left: '50%', // Left position relative to parent
      shadow: '0 0 1px transparent', // Box-shadow for the lines
      position: 'absolute', // Element positioning
    };

    // Create a Spinner instance
    const spinner = new Spinner(spinnerOptions);
    spinnerInstanceRef.current = spinner;

    // Mount spinner to the container
    if (spinnerContainerRef.current) {
      spinner.spin(spinnerContainerRef.current);
    }

    // Cleanup on component unmount
    return () => {
      if (spinnerInstanceRef.current) {
        spinnerInstanceRef.current.stop();
      }
    };
  }, [spinnerContainerRef.current]);

  //Add lottie file here
  if (loading) {
    return <div
      ref={spinnerContainerRef}
      className='app-loading'
      style={{ height: '250px', width: '250px' }}
    >
      {/* <Player
        autoplay
        loop
        src={`${process.env.PUBLIC_URL}/lottie_loading_pill.json`}
        style={{ height: '250px', width: '250px' }}
        onEvent={(event) => console.log("Player event:", event)}
        /> */}
    </div>;
  }

  console.log('customer bucket name: ', customerBucketName);
  console.log('cloudfront url: ', cloudFrontUrl);
  console.log('productSKU: ', productSKU);
  console.log('product tags:', productTags);
  console.log('window asset URL:', window.ASSET_BASE_URL);
  console.log('Show product buttons:', showProductButtons);

  //TODO: Delay
  return (
    !productVariants || !productSKU ? null :
      //Only pass website wide parameters in that file as we need to load variants correctly
      <>
        {enableConfigurator && <button onClick={toggleConfigurator}>Configurator</button>}
        {enableConfigurator && isConfiguratorEnabled && (
          <ProductConfigurator
            productS3BucketUrl={customerBucketName}
            productFolder={productSKU}
            cloudFrontUrl={cloudFrontUrl}
            productVariants={productVariants}
            shopDatabaseType={databaseType.wooCommerce}
            setNewSKU={setProductSKU}
            onClose={toggleConfigurator} // Close overlay
            meshClicked={meshClicked}
            isInteractive = {true}
            productVariantsAttr={productVariantsAttrTest}
            setVariantFoldersNames={setVariantFoldersNames}
          />
        )}
        {/* TODO: Load model as different glbs, find best way to do it. Will have to load one model from each folder.
        Need to use the first configuration in variants as initial value/model. Leverage key, value map to go in the 
        right folder and pick the relevant model */}
        {productSKU !== "" &&
          <Suspense fallback={<div>Loading...</div>}>
            <Main
              productS3BucketUrl={customerBucketName}
              productFolder={productSKU}
              cloudFrontUrl={cloudFrontUrl}
              isAutoPlay={isAutoPlay}
              productVariants={productVariants}
              productTags={productTags}
              productSettings={productSettings}
              configuratorEnabled={isConfiguratorEnabled}
              showAdditionalButtons={showAdditionalButtons && showProductButtons}
              onMeshClicked={onMeshClicked}
              rootDiv={rootDiv}
            />
          </Suspense>
        }
      </>
  );
};
export default ProductViewer;
